import Payments from '@/components/modules/payments-v2/index';
import IndentDetails from '@/components/modules/payments-v2/IndentDetails';
import InvoiceDetails from '@/components/modules/invoices-v2/invoiceDetails';
import Invoices from '@/components/modules/invoices-v2/index';
import WalletV2 from '@/components/modules/wallet-v2/index';
import FreightBill from '@/components/modules/freight-bill/index';

const payments = [
  {
    path: '/v2/payments/',
    name: 'payments',
    component: Payments,
    meta: {
      title: 'Payments',
    },
  },
  {
    path: '/v2/payments/indentdetails',
    name: 'IndentDetails',
    component: IndentDetails,
    meta: {
      title: 'IndentDetails',
    },
  },
  {
    path: '/v2/freight/indentdetails',
    name: 'FreightBillIndentDetails',
    component: IndentDetails,
    meta: {
      title: 'IndentDetails',
    },
  },
  {
    path: '/v2/freight',
    name: 'freightBill',
    component: FreightBill,
    meta: {
      title: 'FreightBill',
    },
  },
  {
    path: '/v2/invoices',
    name: 'invoices',
    component: Invoices,
    meta: {
      title: 'Invoices',
    },
  },
  {
    path: '/v2/invoices/:id',
    name: 'invoiceDetails',
    component: InvoiceDetails,
    meta: {
      title: 'Invoices',
    },
  },
  {
    path: '/v2/wallet',
    name: 'Wallet-v2',
    component: WalletV2,
    meta: {
      title: 'Wallet',
    },
  },
];

export default payments;
